import { render } from "./Empleados-Component.vue?vue&type=template&id=1dcb42c3&scoped=true"
import script from "./Empleados-Component.vue?vue&type=script&lang=js"
export * from "./Empleados-Component.vue?vue&type=script&lang=js"

import "./Empleados-Component.vue?vue&type=style&index=0&id=1dcb42c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcb42c3"]])

export default __exports__